export const GOOGLE_SCOPES = 'profile email';
export const GOOGLE_SCOPES_INVITE =
  'profile email https://www.googleapis.com/auth/contacts.readonly';
